//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_Coin1Ledger } from '@/api';

export default {
  name: 'GoldBeans',
  data() {
    return {
      showRecordsView: false,
      recordTab: 'game',
      records: [],
      recordsLoading: false,
      recordsLoaded: false,
      gameList: [
        {
          name: "Wheel",
          flag: 'coin1_coin_wheel',
          src: require('@/assets/images/home_new/wheel.png'),
          route: { name: 'coin1Wheel' },
        },
        {
          name: "POGGI",
          flag: 'coin1_coin_poggi',
          src: require('@/assets/images/home_new/poggi.png'),
          route: { name: 'coin1Poggi' },
        },
        {
          name: "CHICKEN ROAD",
          flag: 'coin1_coin_chicken',
          src: require('@/assets/images/home_new/cr.png'),
          route: { name: 'coin1ChickenRoad'},
        },
        {
          name: "CRASH",
          flag: 'coin1_coin_crash',
          src: require('@/assets/images/home_new/crash.png'),
          route: { name: 'coin1Crash' },
        }
      ]
    };
  },
  computed: {
    isMobile() {
      return this.$screen && this.$screen.mobile;
    },
    gameRecords() {
      return this.records.filter((item) => /crash|poggi|chicken|游戏/i.test(item.reason));
    },
  },
  watch: {
    recordTab() {
      if (this.showRecordsView) this.fetchRecords();
    },
  },
  methods: {
    openRecordsView(tab) {
      this.recordTab = tab;
      this.showRecordsView = true;
      this.fetchRecords();
    },
    async fetchRecords() {
      if (this.recordsLoading || this.recordsLoaded) return;
      this.recordsLoading = true;
      try {
        const res = await api_Coin1Ledger({ limit: 50 });
        const data = res?.data?.data || res?.data || {};
        const items = Array.isArray(data.items) ? data.items : [];
        this.records = items.map((item) => ({
          id: item.id,
          typeName: item.typeName || item.type || '金豆变动',
          reason: item.reason || item.typeName || item.type || '游戏记录',
          amount: Number(item.amount || 0),
          balance: item.availableBalance ?? item.balance ?? 0,
          time: item.createTime || item.time || '—',
        }));
        this.recordsLoaded = true;
      } catch (error) {
        this.records = [];
        console.error('获取金豆记录失败', error);
      } finally {
        this.recordsLoading = false;
      }
    },
    goToGame(route) {
      const query = { ...(route.query || {}) };
      delete query.uhc;
      delete query.currencyType;
      this.$router.push({ ...route, query });
    },
  },
};
